import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a14c01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "command-container" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "select-box ws_mb20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加设备", -1))
const _hoisted_5 = { class: "select-header" }
const _hoisted_6 = { class: "ws_common_operation" }
const _hoisted_7 = { class: "device-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Qos:0", -1))
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "enter-box" }
const _hoisted_14 = { class: "tag-list" }
const _hoisted_15 = { class: "ws_common_operation ws_mt15" }

import { ref, nextTick, watch, onMounted } from 'vue'
import { CODE_ENUM, MQTT_PRD_CONFIG, MQTT_CONFIG } from '@/common'
import Text from '@/components/text'
import { scrollTop } from '@/utils'
import {
  queryDeviceBindCardList,
  queryDeviceBindCardHistoryList,
  saveDeviceBindCardList,
} from '@/api'
import { cloneDeep } from 'lodash'
import mqtt from 'mqtt'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-command',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const { VUE_APP_ENV } = process.env

const messgaeRef = ref()

const selectKey = ref(Math.random())

const props = __props
const $emit = __emit

const shouldScrollToBottom = () => {
  const scrollEl: any = document.body.querySelector('.message-box')
  // 当前滚动位置
  const scrollTop = scrollEl.scrollTop

  // 可见区域的高度
  const visibleHeight = scrollEl.clientHeight

  // 内容的总高度
  const contentHeight = scrollEl.scrollHeight

  // 判断是否已经滚动到底部
  return scrollTop + visibleHeight + 10 >= contentHeight
}

// 数据滚动到底部
const scrollDown = () => {
  const scrollEl: any = document.body.querySelector('.message-box')
  // 可见区域的高度
  scrollTop(scrollEl, scrollEl.scrollTop, scrollEl.scrollHeight, 100)
}

const checkAll = ref(false)
const indeterminate = ref(false)
const cardCheckValue: any = ref([])
const cardList: any = ref([])

// 点击保存才有下面的
const saveCardCheck: any = ref([])
const saveCardInfoList: any = ref([])

const saveCard = () => {
  saveCardCheck.value = cloneDeep(cardCheckValue.value)
  selectKey.value = Math.random()

  saveCardInfoList.value = cardList.value.filter((_: any) => {
    return cardCheckValue.value.includes(_.deviceSn)
  })

  computedTopic()

  saveDeviceHistoryList()
}

const visibleChange = (visible: boolean) => {
  if (!visible) {
    const value = cloneDeep(saveCardCheck.value)
    cardCheckValue.value = value
    const checkedCount = value?.length || 0
    indeterminate.value =
      checkedCount > 0 && checkedCount < cardList.value.length
    checkAll.value = checkedCount === cardList.value.length
  }
}

const handleCheckAll = (value: boolean) => {
  if (value) {
    cardCheckValue.value = cardList.value.map((_: any) => _.deviceSn)
  } else {
    cardCheckValue.value = []
  }
  indeterminate.value = false
}

const cardCheckChange = (value: any) => {
  const checkedCount = value?.length || 0
  indeterminate.value = checkedCount > 0 && checkedCount < cardList.value.length
  checkAll.value = checkedCount === cardList.value.length
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      createConnection()
    }
  }
)

const client = ref()
const connectLoading = ref(false)
// 创建mqtt连接
const createConnection = () => {
  // const connectUrl = `${protocol}://${host}:${port}/mqtt`;

  const { url, port } =
    VUE_APP_ENV === 'production' ? MQTT_PRD_CONFIG : MQTT_CONFIG
  connectLoading.value = true
  client.value = mqtt.connect(url, {
    port,
    username: '',
    password: '',
    clientId: 'emqx_vue3_' + Math.random().toString(16).substring(2, 8),
  })

  client.value.on('connect', () => {
    connectLoading.value = false
    initUserData()

    console.log('Connection succeeded!')
  })
  client.value.on('error', (error: any) => {
    console.log('connection error:', error)
  })

  client.value.on('message', (topic: string, message: any) => {
    messageList.value.push({
      topic,
      time: moment().format('YYYY-MM-DD HH:mm:ss'),
      message: message.toString(),
      recevice: true,
    })

    const flag = shouldScrollToBottom()
    nextTick(() => {
      flag && scrollDown()
    })
  })
}

// 订阅过的接收topic
const subscribeReceviceList: any = ref([])
// 订阅过的发送topic
const subscribeSendList: any = ref([])

// 判断是否订阅了发送的设备
const isRendDevice = ({ sendTopic }: any) => {
  return subscribeSendList.value.includes(sendTopic)
}

// 获取订阅了发送的设备名
const getSendTopicDeviceDesc = () => {
  return (
    cardList.value
      .map(({ sendTopic, deviceSn }: any) => {
        return subscribeSendList.value.includes(sendTopic)
          ? deviceSn
          : undefined
      })
      .filter(Boolean)
      .join('、') || '-'
  )
}

const commandKey = ref(Math.random())
const commandText = ref('')

const commandHistoryList: any = ref([])

const keydown = (event: any) => {
  if (event?.key === 'Enter' && subscribeSendList.value.length) {
    sendMessage()
  }
}

const sendMessage = (command?: any) => {
  batchSendMessage(command || commandText.value)
  if (!command) {
    commandHistoryList.value.unshift(commandText.value)
    if (commandHistoryList.value.length > 10) {
      commandHistoryList.value.pop()
    }
    commandText.value = ''
    commandKey.value = Math.random()
  }
}

// 批量发送消息
const batchSendMessage = (payload: any) => {
  subscribeSendList.value.map((topic: string) => {
    client.value.publish(topic, payload, { qos: 0 }, (error: any) => {
      if (error) {
        console.log('publish error:', error)
        return
      }
      messageList.value.push({
        topic,
        time: moment().format('YYYY-MM-DD HH:mm:ss'),
        message: payload,
        recevice: false,
      })
      const flag = shouldScrollToBottom()
      nextTick(() => {
        flag && scrollDown()
      })
    })
  })
}

// 对比
const computedTopic = () => {
  const receviceTopicList = saveCardInfoList.value.map(
    (_: any) => _.receiveTopic
  )
  const sendTopicList = saveCardInfoList.value.map((_: any) => _.sendTopic)
  // 未订阅
  const unsubscribeList = receviceTopicList.filter((topic: string) => {
    return !subscribeReceviceList.value.includes(topic)
  })

  // 需要取消订阅的
  const unReceviceList = subscribeReceviceList.value.filter((topic: string) => {
    return !receviceTopicList.includes(topic)
  })
  const unSendList = subscribeSendList.value.filter((topic: string) => {
    return !sendTopicList.includes(topic)
  })

  batchSubscribe(unsubscribeList, 'recevice')
  batchUnSubscribe(unReceviceList, 'recevice')
  batchUnSubscribe(unSendList, 'send')
}

// 删除
const deleteTopic = ({ receiveTopic, sendTopic, deviceSn }: any) => {
  if (subscribeReceviceList.value.includes(receiveTopic)) {
    doUnSubscribe(receiveTopic, 'recevice')
  }
  if (subscribeSendList.value.includes(sendTopic)) {
    doUnSubscribe(sendTopic, 'send')
  }
  saveCardInfoList.value = saveCardInfoList.value.filter((_: any) => {
    return _.deviceSn !== deviceSn
  })
  cardCheckValue.value = cardCheckValue.value.filter((_: any) => {
    return _ !== deviceSn
  })

  saveDeviceHistoryList()
}

const connectRendTopic = ({ sendTopic }: any) => {
  if (subscribeSendList.value.includes(sendTopic)) {
    doUnSubscribe(sendTopic, 'send')
  } else {
    doSubscribe(sendTopic, 'send')
  }
}

// 批量订阅
const batchSubscribe = (topicList: any, type: any) => {
  topicList.map((topic: string) => {
    doSubscribe(topic, type)
  })
}

// 订阅消息
const doSubscribe = (topic: any, type: any) => {
  client.value.subscribe(topic, { qos: 0 }, (error: any, res: any) => {
    if (error) {
      console.log('订阅失败接受topic:', topic)
      return
    }
    if (type === 'recevice') {
      subscribeReceviceList.value.push(topic)
    } else {
      subscribeSendList.value.push(topic)
    }
    console.log('订阅成功接受topic:', topic)
  })
}
// 批量取消订阅
const batchUnSubscribe = (topicList: any, type: any) => {
  topicList.map((topic: string) => {
    doUnSubscribe(topic, type)
  })
}

// 取消订阅
const doUnSubscribe = (topic: any, type: any) => {
  client.value.unsubscribe(topic, { qos: 0 }, (error: any) => {
    if (error) {
      console.log('unsubscribe error:', error)
      return
    }
    if (type === 'recevice') {
      subscribeReceviceList.value = subscribeReceviceList.value.filter(
        (receiveTopic: any) => {
          return topic !== receiveTopic
        }
      )
    } else {
      subscribeSendList.value = subscribeSendList.value.filter(
        (sendTopic: any) => {
          return topic !== sendTopic
        }
      )
    }
    console.log('取消订阅成功topic:', topic)
  })
}

const messageList: any = ref([])
// 防止消息过长
watch(
  messageList,
  () => {
    if (messageList.value.length >= 700) {
      messageList.value = messageList.value.slice(100)
    }
  },
  {
    deep: true,
  }
)

const isCheck = (currentValue: any) => {
  return cardCheckValue.value.includes(currentValue)
}

const queryCardList = async () => {
  const res: any = await queryDeviceBindCardList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    cardList.value = res?.data || []
    console.log(res?.data || [], '-----')
    return Promise.resolve(res?.data || [])
  }
}

const queryDeviceHistoryList = async () => {
  const res: any = await queryDeviceBindCardHistoryList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    console.log(res.data)
    return Promise.resolve(res?.data || [])
  }
}

const saveDeviceHistoryList = async () => {
  const res: any = await saveDeviceBindCardList(saveCardInfoList.value)
  if (res?.code === CODE_ENUM.SUCCESS) {
    console.log(res.data, 'historty')
  }
}

// 初始化用户的信息
const initUserData = async () => {
  const [histortyList, deviceList] = await Promise.all([
    queryDeviceHistoryList(),
    queryCardList(),
  ])
  const snList = histortyList.map((_: any) => _.deviceSn)
  saveCardInfoList.value = deviceList.filter((_: any) => {
    return snList.includes(_.deviceSn)
  })
  cardCheckValue.value = snList
  saveCardCheck.value = cloneDeep(snList)
  visibleChange(false)
  computedTopic()
}

const handleClose = () => {
  $emit('update:visible', false)
  checkAll.value = false
  indeterminate.value = false
  cardCheckValue.value = []
  cardList.value = []
  saveCardCheck.value = []
  saveCardInfoList.value = []
  subscribeReceviceList.value = []
  subscribeSendList.value = []
  commandText.value = ''
  commandHistoryList.value = []
  messageList.value = []

  // 断开链接
  client.value?.end(false, () => {
    client.value = null
    console.log('断开链接')
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: "设备配置",
    width: "1300",
    "before-close": handleClose
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_openBlock(), _createBlock(_component_el_select, {
              modelValue: cardCheckValue.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cardCheckValue).value = $event)),
              multiple: "",
              clearable: "",
              "collapse-tags": "",
              "max-collapse-tags": 1,
              teleported: false,
              key: selectKey.value,
              "popper-class": "custom-select",
              class: "select",
              onChange: cardCheckChange,
              onVisibleChange: visibleChange
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_checkbox, {
                    onChange: handleCheckAll,
                    modelValue: checkAll.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkAll).value = $event)),
                    indeterminate: indeterminate.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 全选 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue", "indeterminate"]),
                  _createElementVNode("span", null, _toDisplayString(cardCheckValue.value.length) + "/" + _toDisplayString(cardList.value.length), 1)
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_button, {
                    onClick: saveCard,
                    plain: "",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.deviceSn,
                    label: item.deviceSn,
                    value: item.deviceSn
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        "model-value": isCheck(item.deviceSn)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Text), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.deviceSn), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["model-value"])
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(saveCardInfoList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["device-item ws_mb12", {
              'send-item': isRendDevice(item),
            }]),
                key: item.deviceSn,
                onClick: ($event: any) => (connectRendTopic(item))
              }, [
                _createVNode(_unref(Text), {
                  content: item.deviceSn,
                  class: "name"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.deviceSn), 1)
                  ]),
                  _: 2
                }, 1032, ["content"]),
                _createVNode(_component_el_popconfirm, {
                  title: "你确定要删除这个设备吗？",
                  onConfirm: () => deleteTopic(item)
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                      class: "icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Delete)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ], 10, _hoisted_8))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", {
            ref_key: "messgaeRef",
            ref: messgaeRef,
            class: "message-box"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["message-item message-receive", { 'message-send': !item.recevice }]),
                key: item
              }, [
                _createElementVNode("p", null, _toDisplayString(item.time), 1),
                _createElementVNode("p", null, " Topic: " + _toDisplayString(item.topic), 1),
                _hoisted_11,
                _createElementVNode("p", null, _toDisplayString(item.message), 1)
              ], 2))
            }), 128))
          ], 512),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(Text), {
              content: getSendTopicDeviceDesc()
            }, {
              default: _withCtx(() => [
                _createTextVNode("发送设备：" + _toDisplayString(getSendTopicDeviceDesc()), 1)
              ]),
              _: 1
            }, 8, ["content"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commandHistoryList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  onClick: ($event: any) => (sendMessage(item)),
                  key: index,
                  class: "tag"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Text), { content: item }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            (_openBlock(), _createBlock(_component_el_input, {
              key: commandKey.value,
              modelValue: commandText.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((commandText).value = $event)),
              class: "text-area",
              rows: 2,
              type: "textarea",
              placeholder: "输入AT指令，例如AT+EXIT",
              resize: "none",
              onKeydown: keydown,
              autofocus: ""
            }, null, 8, ["modelValue"])),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (sendMessage())),
                disabled: !subscribeSendList.value.length || !commandText.value,
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("发送")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ])
      ])), [
        [_directive_loading, connectLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})